import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b1610aa2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b1610aa2&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=b1610aa2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1610aa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1610aa2')) {
      api.createRecord('b1610aa2', component.options)
    } else {
      api.reload('b1610aa2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b1610aa2&scoped=true", function () {
      api.rerender('b1610aa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ossFileUpload/index.vue"
export default component.exports